import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      /* The intro sits 60px above the cards at every width, so the shared
         mobile row gap would land on top of that and make it 75. */
      --block-row-gap: 0px;
    }

    .ignacio-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    .intro {
      grid-column: 2 / 8;
      grid-row: 2;
      --block-intro-gap: var(--text-stack-header-gap);
      padding-bottom: calc(60rem / var(--default-rem-px-count));
      width: 100%;
      color: var(--block-text-color, #222);
    }

    .intro::part(body) {
      display: flex;
      flex-direction: column;
      gap: var(--text-stack-cta-gap);
    }

    /*
      Cards fill left to right and wrap, capped at three per row. Equal 1fr
      tracks separated by one page gutter put every card edge on a page grid
      line: at 360 two cards are 174px, which is 3 of the 6 mobile columns;
      at 768 three cards are 248px, 4 of the 12; at 1440 three cards are
      212px, 2 of the 12.
    */
    .cards {
      grid-column: 2 / 8;
      grid-row: 3;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      column-gap: var(--between-column-padding);
      row-gap: var(--between-row-padding-lg);
      align-items: start;
    }

    .card {
      --driver-card-gap: calc(20rem / var(--default-rem-px-count));
      color: var(--block-text-color, #222);
    }

    /* Foundation Card titles read one tier above driver-card's label
       default. */
    .card::part(title) {
      font-size: var(--fs-title-small);
      line-height: var(--lh-title-small);
      letter-spacing: var(--ls-title-small);
      font-weight: var(--fw-regular);
    }

    @media (min-width: 600px) {
      .intro {
        grid-column: 2 / 14;
        flex-direction: row;
        align-items: baseline;
        --block-intro-gap: var(--between-column-padding);
      }

      .intro::part(header),
      .intro::part(body) {
        flex: 1 1 0;
        min-width: 0;
      }

      .cards {
        grid-column: 2 / 14;
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }
    }

    @media (min-width: 1024px) {
      /* The intro drops to the left four columns and the cards take six,
         which is what keeps each card exactly two columns wide. The twelfth
         column stays empty by design. */
      .intro {
        grid-column: 2 / 6;
        flex-direction: column;
        align-items: stretch;
        align-self: center;
        padding-bottom: 0;
        --block-intro-gap: calc(40rem / var(--default-rem-px-count));
      }

      .intro::part(header),
      .intro::part(body) {
        flex: 0 0 auto;
      }

      .cards {
        grid-column: 7 / 13;
        grid-row: 2;
      }
    }
  `,
];
